"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReads = void 0;
var react_1 = __importDefault(require("react"));
var MeterReads = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 68 68", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("path", { d: "M9.889 65v-6.889h13.778L9.889 65ZM58.111 65v-6.889H44.333L58.111 65Z", fill: "currentColor" }),
    react_1.default.createElement("path", { d: "M65 40.889H3V58.11h62V40.89Z", fill: "currentColor" }),
    react_1.default.createElement("path", { opacity: ".3", d: "M58.111 9.889C58.111 6.1 55.011 3 51.222 3s-6.889 3.1-6.889 6.889H23.667c0-3.789-3.1-6.889-6.89-6.889C12.99 3 9.89 6.1 9.89 9.889H3v31h62v-31h-6.889Zm-6.889 22.389H16.778V18.5h34.444v13.778Z", fill: "currentColor" }))); };
exports.MeterReads = MeterReads;
